import RestService from './rest.service';
import store from 'redux/store';
import { Translations } from 'redux/actions';
import CacheService from '@components/collection/components/globals/backend-services/cache.service';
var TRANSLATIONS = 'api/v1/customerfacing/cftranslations/language/';
var TRANSLATIONV2 = 'api/v2/customerfacing/cftranslations/language/';
var TranslationService = {
  getTranslations: function getTranslations(lang) {
    return new Promise(function (resolve, reject) {
      RestService.request(TRANSLATIONS + lang, {
        method: "POST"
      }, true).then(function (data) {
        resolve(data);
      }).catch(function (data) {
        reject(data);
      });
    });
  },
  getTranslationsV2: function getTranslationsV2(lang, categories) {
    return new Promise(function (resolve, reject) {
      CacheService.cacheRequest(TRANSLATIONV2 + lang + '/category/multiple' + categories.split(','), function () {
        return RestService.request(TRANSLATIONV2 + lang + '/category/multiple', {
          method: "POST",
          body: categories.split(',')
        }, true, {}, true);
      }).then(function (data) {
        resolve(data);
      }).catch(function (data) {
        reject(data);
      });
    });
  },
  translations: {},
  forLang: [],
  init: function init(lang) {
    TranslationService.getTranslations(lang).then(function (res) {
      store.dispatch(Translations.setTranslations(res));
    });
  },
  initV2: function initV2(lang, categories) {
    TranslationService.getTranslationsV2(lang, categories).then(function (res) {
      if (store.getState().translations.data) {
        store.dispatch(Translations.setTranslations(Object.assign({}, store.getState().translations.data, res)));
      } else {
        store.dispatch(Translations.setTranslations(res));
      }
    });
  },
  t: function t(key, defaultTranslation) {
    var value = TranslationService.forLang[key];
    return value && value.length > 0 ? value : defaultTranslation;
  }
};
export default TranslationService;